<div
  class="mr-2"
  [ngClass]="{ 'hide-on-mobile': brandingKey === CustomClients.Vorwerk }"
  *ngIf="((brandingKey === CustomClients.Vorwerk && collectionOwner) || brandingKey !== CustomClients.Vorwerk) && !['shareCollection', 'publishCollection'].includes(configObject?.callFrom || '')"
>
  <button mat-icon-button (click)="openMenu()">
    <mat-icon class="material-icons-outlined">more_vert</mat-icon>
    <div class="overlayMenu" matTooltip="Asset actions" #taskMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="assetActionMenu"></div>
  </button>
  <mat-menu #assetActionMenu="matMenu" yPosition="below" xPosition="before" [overlapTrigger]="false">
    <ng-container *ngTemplateOutlet="actionTemplate"></ng-container>
  </mat-menu>
</div>
<ng-template #actionTemplate>
  <div #actions class="asset-gallery-actions-menu">
    <span class="cursor-pointer" i18n-matTooltip matTooltip="Edit Collection">
      <button mat-menu-item *ngIf="collectionOwner" (click)="editCollection.emit(collection._id)" class="hide-on-mobile">
        <mat-icon>
          <span class="material-icons-outlined">edit</span>
        </mat-icon>
        <span i18n>Edit collection</span>
      </button>
    </span>
    <span *ngIf="brandingKey !== CustomClients.Vorwerk" class="cursor-pointer" i18n-matTooltip matTooltip="Download Collection">
      <button mat-menu-item (click)="downloadCollection.emit(collection._id)">
        <mat-icon>
          <span class="material-icons-outlined">file_download</span>
        </mat-icon>
        <span i18n>Download collection</span>
      </button>
    </span>
    <span class="cursor-pointer hide-on-mobile" i18n-matTooltip matTooltip="Publish collection">
      <button mat-menu-item *ngIf="collectionOwner && !collectionPublished" (click)="publishCollection.emit(collection._id)">
        <mat-icon>
          <span class="material-icons-outlined">feed</span>
        </mat-icon>
        <span i18n>Publish collection</span>
      </button>
    </span>
    <span class="cursor-pointer hide-on-mobile" i18n-matTooltip matTooltip="Unpublish collection">
      <button mat-menu-item *ngIf="collectionOwner && collectionPublished" (click)="unpublishCollection.emit(collection._id)">
        <mat-icon>
          <span class="material-icons-outlined">feed</span>
        </mat-icon>
        <span i18n>Unpublish collection</span>
      </button>
    </span>
    <span class="cursor-pointer" *ngIf="brandingKey !== CustomClients.Vorwerk" i18n-matTooltip matTooltip="Share Collection">
      <button *ngIf="!assetDetails && (AnyAsset | can: 'share')" mat-menu-item (click)="shareCollection.emit(collection._id)">
        <mat-icon>
          <span class="material-icons-outlined">share</span>
        </mat-icon>
        <span i18n>Share collection</span>
      </button>
    </span>
    <span class="cursor-pointer hide-on-mobile" i18n-matTooltip matTooltip="Delete collection">
      <button *ngIf="collectionOwner" mat-menu-item (click)="deleteCollection.emit(collection._id)">
        <mat-icon>
          <span class="material-icons-outlined">delete_outline</span>
        </mat-icon>
        <span i18n>Delete collection</span>
      </button>
    </span>
  </div>
</ng-template>
